module.exports = __webpack_public_path__ + "static/img/108_TO8_1799.083697b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/108_TO8_1799.jpg
// module id = +4xM
// module chunks = 0